module.exports = __webpack_public_path__ + "img/graph-icon.7a2af1a9.svg";